import { inject, Injectable } from "@angular/core";
import { from, Observable } from "rxjs";

import { BaseService } from "../common/services/base-service";
import { environment } from "../../environments/environment";
import { ReusableService } from "../common/services/reusable-services";
import { getFooterMocked } from "../common/utils/api-mocks";
import { API_PATHS } from "../common/constants/api-paths";
import { ApiResponse } from "../common/models/api-response.model";
import { FooterResult } from "./footer.model";
import { CacheService } from "../common/services/cache-service";
import { CACHE_KEYS } from "../common/constants/cache-keys";

@Injectable({
  providedIn: "root",
})
export class FooterService {
  baseService = inject(BaseService);
  reusableService = inject(ReusableService);
  cacheService = inject(CacheService);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getFooter(): Observable<ApiResponse<FooterResult>> {
    if (!environment.STUBS) {
      return getFooterMocked();
    } else {

      // eslint-disable-next-line no-useless-catch
      const selectedLang = this.reusableService.getApplicableLanguage();

      //get userDetails from cache
      const userDetails = this.cacheService.getFromCache(CACHE_KEYS.USER.USER_DETAILS);

      const req = {
        componentType: "",
        experienceFragments: [
          `/content/srp/global/${selectedLang.languageCode}/footer`,
        ],
        userDetails: {
          userName: userDetails?.userName ?? '',
          userId: "",
          email: "",
          userType: "",
          market: "",
          isAdmin: userDetails?.isAdmin ?? false,
          currentContext: {
            businessUnit: "",
            roleName: userDetails?.roleName ?? 'Independent-Repairer',
            dealerCode: "",
            dealerName: "",
            languageCode: "",
          },
          userFirstName: "",
          userLastName: "",
          sessionId: "",
        },
      };

      return from(this.baseService.post<ApiResponse<FooterResult>>(API_PATHS.PORTAL.GET_FOOTER, req));
    }
    //return results;
  }
}
